"use strict";

import Error404 from "../views/error-pages/Error404.js";
import Landing from "../views/pages/Landing.js";
import { Leftpanel } from "../views/components/Leftpanel.js";
import Betslip from "../views/components/Betslip.js";
import { updatePrevHash, setLastHash, lastHash } from "../services/state.js";

import Bottombar from "../views/components/Bottombar.js";
import Utils from "../services/Utils.js";
import { getCurrentBalance } from "../js/api/balance.js";
import { getJackPotValue } from "./api/jackpot.js";
import IframeModal from "../views/components/IframeModal.js";
import JackpotModal from "../views/components/JackpotModal.js";
import Header from "../views/components/Header.js";
import TranslationService from "../services/TranslationService.js";
import Login from "../views/components/Login.js";
import {
  checkForUserGroup,
  getUserGroup,
  transformSingleCoef,
} from "../services/UserGroup.js";

// import About from "../views/pages/About.js";
// import PostShow from "../views/pages/PostShow.js";
import Sports from "../views/pages/Sports.js";
// import { Leagues } from "../views/pages/League.js";
import GameByLeague from "../views/pages/GameByLeague.js";
import Match from "../views/pages/Match.js";
import LiveMatch from "../views/pages/LiveMatch.js";
import MyBets from "../views/pages/MyBets.js";
// import MyBetsUsers from "../views/pages/MyBetsUsers.js";
// import MyBetsUserDetails from "../views/pages/MyBetsUserDetails.js";
import AccountBalance from "../views/pages/AccountBalance.js";
// import SmFinances from "../views/pages/SmFinances.js";
// import CurrentBalance from "../views/pages/CurrentBalance.js";
// import CreateUsers from "../views/pages/CreateUsers.js";
// import Users from "../views/pages/Users.js";
// import UserProfile from "../views/pages/UserProfile.js";
// import LiveCasino from "../views/pages/LiveCasino.js";

import InPlay from "../views/pages/InPlay.js";
// import Jackpot from "../views/pages/Jackpot.js";
import ChangePassword from "../views/pages/ChangePassword.js";
import Terms from "../views/pages/Terms.js";
import { setBlockedSports } from "../services/BlockedSports.js";

// import Slots from "../views/pages/Slots.js";
// import MyBetsUsersAgent from "../views/pages/MyBetsUsers_Agent.js";
// import VirtualGames from "../views/pages/VirtualGames.js";

var routes = {
  "/": Landing,
  // "/about": About,
  // "/p/:id": PostShow,
  "/sports/:id": Sports,
  // "/league/:id": Leagues,
  "/games/:id": GameByLeague,
  "/match/:id": Match,
  "/livematch/:id": LiveMatch,
  "/inplay": InPlay,
  // "/inplay/:id": InPlay,
  "/mybets": MyBets,
  // "/mybetsusers": MyBetsUsers,
  // "/mybetsusers-agent": MyBetsUsersAgent,
  // "/mybetsuserdetails/:id": MyBetsUserDetails,
  "/changepassword": ChangePassword,
  "/accountbalance": AccountBalance,
  "/terms": Terms,
  // "/smfinances": SmFinances,
  // "/currentbalance": CurrentBalance,
  // "/createnewuser": CreateUsers,
  // "/users": Users,
  // "/slots": Slots,
  // "/virtual-games": VirtualGames,
  // "/userprofile/:id": UserProfile,
  // "/jackpot": Jackpot,
  // "/live-casino": LiveCasino,
};

var socket = io("//xbet.socketi355.com:1440", { transports: ["websocket"] });

var on_unloadFunction;

socket.on("jackpot.released", async function (res, callback) {
  if (
    localStorage.getItem("username").toLowerCase() == res.username.toLowerCase()
  ) {
    if (res.from_client) return;

    if (res.released) {
      await JackpotModal.after_render();

      setTimeout(() => {
        JackpotModal.show(5000, res.value, res.type);
      }, 3000);
    } else if (res.checking) {
      callback(localStorage.getItem("isOnSlots") == "true");
    }
  }
});

socket.on("new-coefs", function (res) {
  if (!res || !res.coefs) return;
  const userGroup = getUserGroup(); // Fetch user group
  res.coefs.forEach((data) => {
    data = transformSingleCoef(data, userGroup);

    var div = document.getElementsByClassName(data.coef_id)[0];

    var span = document.getElementsByClassName(data.coef_id + "-span");
    var bs = document.getElementsByClassName(data.coef_id + "-bs");
    if (div) {
      if (
        document.getElementsByClassName(data.coef_id)[0].children.length < 2
      ) {
        document
          .getElementsByClassName(data.coef_id)[0]
          .textNodes()[0].textContent = Utils.formatNumber(data.odd);
      }
      document
        .getElementsByClassName(data.coef_id)[0]
        .setAttribute("match-odd", Utils.formatNumber(data.odd));
    }
    if (bs) {
      let coefHasChanged = localStorage.getItem("coefHasChanged");
      for (let index = 0; index < bs.length; index++) {
        let element = bs[index];
        const oldPrice = element.getAttribute("match-odd")
          ? element.getAttribute("match-odd")
          : element.outerText;
        if (Utils.formatNumber(data.odd) == Utils.formatNumber(oldPrice))
          continue;

        let color =
          Utils.formatNumber(data.odd) > Utils.formatNumber(oldPrice)
            ? "green"
            : "red";
        element.setAttribute("match-odd", Utils.formatNumber(data.odd));
        element.innerHTML = `<span style=" text-decoration: line-through;">${Utils.formatNumber(
          oldPrice
        )}</span><span style="color:${color}">${Utils.formatNumber(
          data.odd
        )}</span>`;

        coefHasChanged = true;
      }

      calculatePrice();

      if (coefHasChanged == true) {
        localStorage.setItem("coefHasChanged", coefHasChanged);
        $("#btnDescription").text("Prano ndryshimet");
        $("#valueIcon").text("");
        $("#placeBetValue").text("");
      }
    }

    if (span) {
      for (let index = 0; index < span.length; index++) {
        let element = span[index];
        element.setAttribute("match-odd", Utils.formatNumber(data.odd));
        element.innerHTML = `<span>${Utils.formatNumber(data.odd)}</span>`;
      }
      calculatePrice();
    }
    updateCoefLocalStorage(data.coef_id, data.odd);
  });

  updateMatch();
});

socket.on("delete-live-game", function (data) {
  var liveGame = document.getElementById(data.id);

  if (liveGame) {
    liveGame.parentNode.removeChild(liveGame);
    //liveGame.innerHTML = "";
  }
});

socket.on("delete-live-coef", function (data) {
  var liveCoef = document.getElementsByClassName(`${data.id}-coef`);

  if (liveCoef && liveCoef[0]) {
    liveCoef[0].innerText = "1.00";
  }
});

function eraseCache(version) {
  const href = window.location.href.split("?")[0];
  window.location = href;
}

var setDefaults = async function () {
  try {
    if (location.hostname == "sportgamble.net") {
      // Leave only English language for sportgamble.net
      TranslationService.defaultLang = "en";
      TranslationService.languages = [{ key: "en", name: "English" }];
    }

    await TranslationService.loadTranslations().then(() => {
      TranslationService.translateStatics();
    });
  } catch {}

  localStorage.setItem("isOnSlots", false);

  if (localStorage.getItem("access_token")) {
    try {
      await withTimeout(
        setCurrentBalance({ reloadOnBlockedSportsChange: false }),
        8000,
        "initial balance"
      );
    } catch (error) {
      console.error("Could not load blocked sports before render:", error);
    }
  } else {
    setBlockedSports([]);
  }

  const lastVersionDate = localStorage.getItem("version-date-1");
  const ONE_HOUR = 60 * 60 * 1000;

  if (!lastVersionDate || new Date() - new Date(lastVersionDate) > ONE_HOUR) {
    localStorage.setItem("version-date-1", new Date());
    eraseCache(new Date().getTime());
  }

  var header = null || document.getElementById("header_container");
  var footer = null || document.getElementById("footer_container");
  var betslip = null || document.getElementById("betslip");

  header.innerHTML = `${await Header.render()}  ${await JackpotModal.render()}`;
  await Header.after_render();

  betslip.innerHTML = await Betslip.render();
  await Betslip.after_render();

  // footer.innerHTML = `${await Bottombar.render()}  ${await IframeModal.render()}`;
  await Bottombar.after_render();
  await IframeModal.after_render();

  var itemArray = JSON.parse(localStorage.getItem("addObject")) || [];
  itemArray.forEach((item) => {
    socket.emit("connectToRoom", { room: item.gameId });
  });
};

function updateActiveSportsLink() {
  const currentUrl = window.location.hash; // Get current hash URL
  const currentSportId = currentUrl.startsWith("#/sports/")
    ? currentUrl.split("/")[2]
    : localStorage.getItem("matchSport");

  document.querySelectorAll(".betModuleSportBtn").forEach((link) => {
    const sportId = link.getAttribute("sportid");

    if (sportId === currentSportId) {
      link.classList.add("bg-[#81011e]"); // Add active styles
      link.classList.remove("hover:bg-[#8d741d]"); // Remove hover effect
    } else {
      link.classList.remove("bg-[#81011e]");
      link.classList.add("hover:bg-[#8d741d]");
    }
  });

  if (
    currentUrl === "#/accountbalance" ||
    currentUrl === "#/mybets" ||
    currentUrl === "#/terms" ||
    currentUrl === "#/changepassword"
  ) {
    document.body.classList.add("full-screen");
  } else {
    document.body.classList.remove("full-screen");
  }
}

// small helper: Promise timeout watchdog
function withTimeout(promise, ms, label = "operation") {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error(`Timeout: ${label}`)), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

var router = async function () {
  const login = document.getElementById("login_container");
  const content = document.getElementById("content_container");
  const request = Utils.parseRequestURL();

  const parsedURL =
    (request.resource ? "/" + request.resource : "/") +
    (request.id ? "/:id" : "") +
    (request.verb ? "/" + request.verb : "");

  $("body .mainHolderPanel").append(`
    <div id="routeLoader" class="absolute top-0 left-0 w-full h-full bg-[#0e0e0ebd] flex items-center justify-center z-50">
      <div class="loader border-t-4 border-white-500 border-solid rounded-full w-12 h-12 animate-spin"></div>
    </div>`);

  const removeLoader = () => $("body #routeLoader").remove();

  try {
    await withTimeout(saveJackpotValue(), 8000, "saveJackpotValue");

    // Login render/after_render
    login.innerHTML = await withTimeout(Login.render(), 8000, "Login.render");
    await withTimeout(Login.after_render(), 8000, "Login.after_render");

    // Route resolve
    const page = routes[parsedURL] ? routes[parsedURL] : Error404;
    window.scrollTo(0, 0);

    if (on_unloadFunction) on_unloadFunction(socket);

    // Page render/after_render
    content.innerHTML = await withTimeout(page.render(), 15000, "page.render");
    await withTimeout(page.after_render(socket), 15000, "page.after_render");

    on_unloadFunction = page.on_unload;

    await withTimeout(updateMatch(), 8000, "updateMatch");

    // Remove loader after successful render
    setTimeout(removeLoader, 10);

    await setCurrentBalance();
    updateActiveSportsLink();
  } catch (err) {
    console.error("Router error:", err);

    // Always remove loader on error
    removeLoader();

    // Try to show a minimal fallback so UI isn't blank
    try {
      content.innerHTML = `<div class="p-3 text-sm text-white bg-black/60">
        Something went wrong loading this page${
          err?.message ? `: <em>${err.message}</em>` : ""
        }.
      </div>`;
    } catch {}

    // Reload ONCE to recover from transient issues/hangs
    const reloadFlag = "routerReloadedOnce";
    if (!sessionStorage.getItem(reloadFlag)) {
      sessionStorage.setItem(reloadFlag, "1");
      location.reload(); // refresh once
      return;
    } else {
      // we've already retried once; clear flag for future navigations
      sessionStorage.removeItem(reloadFlag);
    }
  } finally {
    // Belt & suspenders: ensure loader is gone even if setTimeout didn’t fire
    removeLoader();
  }
};

async function loadLiveCasino() {
  window.location.href = "#/live-casino";
}

async function saveJackpotValue() {
  const value = await getJackPotValue();
  if (value) {
    localStorage.setItem(
      "jackpot_value",
      Utils.formatNumber(value.actual_jackpot)
    );
    localStorage.setItem(
      "jackpot_live",
      Utils.formatNumber(value.actual_jackpot_live)
    );
    localStorage.setItem(
      "jackpot_prematch",
      Utils.formatNumber(value.actual_jackpot_prematch)
    );
  }
}
if (axios && axios.interceptors && axios.interceptors.response) {
  axios.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (!response || (response && !response.data)) {
        return response;
      }

      if (response.data.error == "Expired token") {
        localStorage.removeItem("role");
        localStorage.removeItem("name");
        localStorage.removeItem("access_token");
        localStorage.removeItem("surname");
        location.reload(true);
      }

      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Handle 401 Unauthorized globally
      if (error.response && error.response.status === 401) {
        localStorage.clear(); // Clear all local storage
        window.location.href = "#/"; // Redirect to home
      }

      return Promise.reject(error);
    }
  );
}

var i = 0;

function getCombinations(input, size) {
  var results = [],
    result,
    mask,
    total = Math.pow(2, input.length);
  for (mask = 0; mask < total; mask++) {
    result = [];
    i = input.length - 1;
    do {
      if ((mask & (1 << i)) !== 0) {
        result.push(input[i]);
      }
    } while (i--);

    //ne qofte se duhen edhe bastet teke edhe vareja duhet ky rresht
    // if (result.length <= size && result.length > 0) {
    //perndryshe duhet ky
    if (result.length == size && result.length > 1) {
      results.push(result);
    }
  }
  //console.log(results);
  return results;
}

function treatCombinations(s) {
  var min = false;
  var max = [];
  var maxOdd = false;
  var arr = s;
  var l = arr.length;
  let value = 0;
  let element = document.getElementById("placeBetAreaValue");
  if (element && element.value) value = parseFloat(element.value) / l;

  var i = 0;
  for (; i < l; ) {
    (function (q) {
      var odd = value;
      for (var j in q) {
        odd = odd * q[j];
      }
      if (!min) {
        min = odd;
      } else if (odd < min) {
        min = odd;
      }
      if (!maxOdd) {
        maxOdd = odd;
      } else if (odd > maxOdd) {
        maxOdd = odd;
      }
      max.push(odd);
    })(arr[i]);
    i = i + 1;
  }

  let newMax = 0;
  for (let index = 0; index < max.length; index++) {
    var element1 = max[index];
    newMax += element1;
  }

  return {
    min: min,
    max: max,
    maxOdd: maxOdd,
    combNo: l,
    newMax,
  };
}

async function setCurrentBalance({ reloadOnBlockedSportsChange = true } = {}) {
  var currentBalanceResult = await getCurrentBalance();
  if (!currentBalanceResult) return null;

  const blockedSportsChanged = setBlockedSports(
    currentBalanceResult["blocked_sports"] || []
  );
  var coins = [];
  var allText = "";

  if (currentBalanceResult && currentBalanceResult.total_coins) {
    var allCoins = currentBalanceResult.total_coins.split("|");

    if (currentBalanceResult.total_coins.includes("|")) {
      var allCoins = currentBalanceResult.total_coins.split("|");

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(";")[0].split(".")[1];
        coins.push({
          currency,
          id: coin.split(";")[0].split(".")[0],
        });

        const value = coin.split(";")[1];
        allText += `<b>${currency} ${parseFloat(value).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}</b>`;
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
        allText += `<b>${currentBalanceResult.currency} ${parseFloat(
          currentBalanceResult.total_coins
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}</b>`;
      } else {
        const currency = currentBalanceResult.total_coins
          .split(";")[0]
          .split(".")[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(";")[0].split(".")[0],
        });

        const value = currentBalanceResult.total_coins.split(";")[1];
        allText += `<b>${currency} ${parseFloat(value).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}</b>`;
      }
    }

    $(".currentBalanceNew").html(allText);

    localStorage.setItem("coins", JSON.stringify(coins));
  }

  if (blockedSportsChanged && reloadOnBlockedSportsChange) {
    window.location.reload();
  }

  return currentBalanceResult;
}

function calculatePrice(value) {
  if (!value) {
    value = document.getElementById("placeBetAreaValue").value;
  }
  let totalValue = 1;

  itemArray.forEach((item) => {
    totalValue = totalValue * item.coefVal;
  });
  totalValue = totalValue * value;

  var size = $("#systemBtn").val();

  if (size && size !== "-1") {
    var odds = [];

    itemArray.forEach((element) => {
      odds.push(element.coefVal);
    });

    var s = getCombinations(odds, size);
    var r = treatCombinations(s);

    $("#winningPrice")[0].innerHTML = ` ${Utils.formatNumber(
      r.min
    )} / ${Utils.formatNumber(r.newMax)}`;
  } else {
    document.getElementById("winningPrice").textContent =
      Utils.formatNumber(totalValue);
  }
}

window.addEventListener(
  "addToRoom",
  function (e) {
    socket.emit("connectToRoom", { room: e.detail });
  },
  false
);

window.addEventListener(
  "loadLiveCasino",
  function (e) {
    loadLiveCasino();
  },
  false
);

window.addEventListener(
  "leaveRoom",
  function (e) {
    let itemArray = JSON.parse(localStorage.getItem("addObject")) || [];
    var check = itemArray.filter((a) => a.gameId == e.detail);
    if (!check || check <= 0) {
      socket.emit("leaveRoom", { room: e.detail });
    }
  },
  false
);

window.addEventListener("load", async () => {
  await defaultsReady;
  updatePrevHash(""); // nothing before initial page
  setLastHash(window.location.hash || ""); // current hash now
  router(); // initial render
});

// Keep prev/last fresh on every hash change, then route
window.addEventListener("hashchange", (e) => {
  const oldHash = (e?.oldURL && new URL(e.oldURL).hash) || lastHash || "";
  const newHash =
    (e?.newURL && new URL(e.newURL).hash) || window.location.hash || "";
  updatePrevHash(oldHash);
  setLastHash(newHash);
  router();
});

window.addEventListener("load", async () => {
  await defaultsReady;
  var leftpanel = document.getElementById("leftpanel_container");
  leftpanel.innerHTML = await Leftpanel.render();
  await Leftpanel.after_render();
});

const defaultsReady = setDefaults();

document.addEventListener("visibilitychange", async function () {
  if (document.visibilityState === "visible") {
    await setCurrentBalance();
  }
});

checkForUserGroup();
